/**
 * Destination identifiers for hotel search (city, hotel, or Google/TBO location).
 */

export function hasValidSearchCoordinates(latitude, longitude) {
  const lat = Number(latitude);
  const lng = Number(longitude);
  return Number.isFinite(lat)
    && Number.isFinite(lng)
    && lat !== 0
    && lng !== 0
    && lat >= -90
    && lat <= 90
    && lng >= -180
    && lng <= 180;
}

export function hasHotelSearchDestination({
  cityId,
  hotelCode,
  locationId,
  latitude,
  longitude,
} = {}) {
  return Boolean(
    cityId
    || hotelCode
    || locationId
    || hasValidSearchCoordinates(latitude, longitude)
  );
}

export function isTboNumericCityId(value) {
  const raw = String(value ?? '').trim();
  if (!/^\d+$/.test(raw)) return false;
  return Number.parseInt(raw, 10) > 0;
}

export function shouldSearchByCityCode({ cityId, locationId } = {}) {
  if (locationId) return false;
  return isTboNumericCityId(cityId);
}

export function hotelSearchDestinationLabel({
  searchLocationName,
  hotelName,
  cityName,
} = {}) {
  return String(searchLocationName || hotelName || cityName || '').trim();
}

export function pickLocationId(item) {
  if (!item || typeof item !== 'object') return '';
  const direct = item.locationId || item.sourceId || item.placeId;
  if (direct) return String(direct).trim();
  const isLocation = item.type === 'location' || Boolean(item.locationType);
  if (isLocation && item.id) return String(item.id).trim();
  return '';
}

export function appendHotelGeoSearchParams(params, { latitude, longitude } = {}) {
  if (!hasValidSearchCoordinates(latitude, longitude)) return params;
  params.set('lat', String(latitude));
  params.set('lng', String(longitude));
  return params;
}

export function readHotelGeoSearchParams(searchParams) {
  if (!searchParams || typeof searchParams.get !== 'function') return {};
  const latitude = Number(searchParams.get('lat'));
  const longitude = Number(searchParams.get('lng'));
  if (!hasValidSearchCoordinates(latitude, longitude)) return {};
  return { latitude, longitude };
}

export function applyHotelGeoToSearchBody(body, { latitude, longitude } = {}) {
  if (!hasValidSearchCoordinates(latitude, longitude)) return body;
  body.latitude = Number(latitude);
  body.longitude = Number(longitude);
  return body;
}
